import { ACTIVATE_MODAL, DISMISS_MODAL } from './modal-manager-actions';

export default function (state = [], action) {
  switch (action.type) {
    case ACTIVATE_MODAL: {
      return [...state, action.modal];
    }
    case DISMISS_MODAL: {
      return state.filter((_, i) => i !== state.length - 1);
    }
    default:
      break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./containers/modal-manager/modal-manager-reducer.js